<script>
  import TrendIndicator from './TrendIndicator.svelte';

  export let capacity = 3;
  export let value = '';
  export let trend = null;
  export let previousCapacity = null;
  export let label = '';
  export let showLabel = true;
  export let showTrend = true;

  const allowedTrends = ['na', 'up', 'down', 'flat'];

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  $: resolvedCapacity = clamp(Math.ceil(Number(capacity) || 1), 1, 5);
  $: resolvedValue = value === null || value === undefined ? '' : value;
  $: resolvedPreviousCapacity = previousCapacity == null
    ? resolvedCapacity
    : clamp(Math.ceil(Number(previousCapacity) || 1), 1, 5);
  $: calculatedTrend = !previousCapacity
    ?'na' 
    :capacity > previousCapacity
    ? 'up'
    : capacity < previousCapacity
    ? 'down'
    : 'flat';
  $: resolvedTrend = allowedTrends.includes(trend) ? trend : calculatedTrend;
</script>

<div class="capacity-cell" data-capacity={resolvedCapacity}>
  <div class="capacity-cell__main">
    <div class="capacity-cell__value">{resolvedValue}</div>

    {#if showTrend}
      <TrendIndicator trend={resolvedTrend} size="cell" />
    {/if}
  </div>

  {#if showLabel && label}
    <p class="capacity-cell__label">{label}</p>
  {/if}
</div>
